import React from "react";
import WorkOrdersAnalytics from "../../views/WorkOrderAnalytics";

const WorkOrderAnalyticsDashboardPage = () => {
  return <WorkOrdersAnalytics />;
};

export default WorkOrderAnalyticsDashboardPage;
